import React from 'react';
import PropTypes from 'prop-types';

export default function ConnectionDetails(props) {
  const { name, subtitle } = props;

  return (
    <React.Fragment>
      <div>
        <strong>{name}</strong>
      </div>
      <div>{subtitle}</div>
    </React.Fragment>
  );
}

ConnectionDetails.propTypes = {
  name: PropTypes.string.isRequired,
  subtitle: PropTypes.string
};
